/**
 * Staff Requisitions module — Excel export.
 *
 * Was a hand-rolled HTML-table-as-.xls trick (duplicated across Inventory/Assets/Procurement/
 * Requisitions). Consolidated 2026-07-13 to the shared, letterheaded xlsx exporter — see
 * src/features/inventory/utils/export.ts for the identical rationale. Same function name/
 * signature, now async, downloads .xlsx instead of .xls.
 */
import { exportToXlsx, type ExportRow } from "#/lib/xlsxExport";

export type { ExportRow };

export function downloadXls(filename: string, title: string, headers: string[], rows: ExportRow[]): Promise<void> {
  return exportToXlsx({ filename, title, headers, rows });
}
